// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();

//     const form = this.closest('form');
//     if (!form) return;

//     this.input = form.querySelector('[data-predictive-search-input]');
//     this.results = this.querySelector('[data-predictive-search]');
//     this.status = this.querySelector('[data-predictive-search-status]');
//     this.abortController = null;

//     if (!this.input || !this.results) return;

//     this.input.addEventListener('input', this.onChange.bind(this));
//   }

//   onChange() {
//     const query = this.input.value.trim();

//     if (query.length < 2) {
//       this.results.innerHTML = '';
//       this.setExpanded(false);
//       return;
//     }

//     this.search(query);
//   }

//   search(query) {
//     if (this.abortController) this.abortController.abort();
//     this.abortController = new AbortController();

//     fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,query&resources[limit]=10&resources[options][unavailable_products]=hide`, { 
//     signal: this.abortController.signal 
//     })
//       .then(r => r.json())
//       .then(data => {
//         const { queries = [], products = [], articles = [] } =
//         data.resources.results;

//         console.log('Products:', products);

//         this.results.innerHTML = `
//         <div class="predictive-search-layout">

//             <div class="predictive-search-left">
//             ${queries.length ? `
//                 <div class="predictive-search-group">
//                 <h4>Popular Suggestions</h4>
//                 <ul>
//                     ${queries.map(q => `
//                     <li>
//                         <a href="/search?q=${encodeURIComponent(q.text)}">
//                          ${q.text}
//                         </a>
//                     </li>
//                     `).join('')}
//                 </ul>
//                 </div>
//             ` : ''}

//             ${articles.length ? `
//                 <div class="predictive-search-group">
//                 <h4>Blogs & Recipes</h4>
//                 <ul>
//                     ${articles.map(a => `
//                     <li>
//                         <a href="${a.url}">
//                         ${a.title}
//                         </a>
//                     </li>
//                     `).join('')}
//                 </ul>
//                 </div>
//             ` : ''}
//             </div>

//             <div class="predictive-search-right">
//             <h4>Products</h4>
//             <div class="predictive-search-products">
//                 ${products.map(p => `
//                 <a href="/products/${p.handle}" class="predictive-product-card">
//                     <img src="${p.image}" alt="${p.title}">
//                     <div class="predictive-product-info">
//                     <p class="title">${p.title}</p>
//                     <p class="price">£${p.price}</p>
//                     </div>
//                 </a>
//                 `).join('')}
//             </div>
//             </div>

//             <a href="/search?q=${encodeURIComponent(query)}" class="predictive-search-view-all">
//                 View all results →
//             </a>
//         </div>

//         `;

//         this.setExpanded(true);

//             })
//             .catch(() => {});
//         }

//         setExpanded(open) {
//             this.input.setAttribute('aria-expanded', open);
//             this.results.style.display = open ? 'block' : 'none';
//         }
//     }

// customElements.define('predictive-search', PredictiveSearch);
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    const form = this.closest('form');
    if (!form) return;

    this.input = form.querySelector('[data-predictive-search-input]');
    this.results = this.querySelector('[data-predictive-search]');
    this.status = this.querySelector('[data-predictive-search-status]');
    this.abortController = null;

    if (!this.input || !this.results) return;

    this.input.addEventListener('input', this.onChange.bind(this));
    
    // Add debounce to prevent too many requests
    this.onChange = this.debounce(this.onChange.bind(this), 300);
  }

  // Debounce function to prevent too many API calls
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  onChange() {
    const query = this.input.value.trim();

    if (query.length < 2) {
      this.results.innerHTML = '';
      this.setExpanded(false);
      return;
    }

    this.search(query);
  }

  async search(query) {
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    try {
      // Use only Shopify's built-in suggest endpoint
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,query&resources[limit]=10`,
        { 
          signal: this.abortController.signal,
          headers: {
            'Accept': 'application/json'
          }
        }
      );

      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        console.error('Response is not JSON:', contentType);
        throw new Error('Server did not return JSON');
      }

      const data = await response.json();
      
      // Extract products - limit to 3
      const products = (data.resources?.results?.products || []).slice(0, 3);
      const queries = data.resources?.results?.queries || [];
      const articles = data.resources?.results?.articles || [];

      // If no products from suggest.json, try a different approach
      if (products.length === 0 && query.length >= 3) {
        await this.fallbackSearch(query);
        return;
      }

      this.renderResults(products, queries, articles, query);
      this.setExpanded(true);

    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Search error:', err);
        this.showErrorMessage(query);
      }
    }
  }

  // Fallback: Use the regular search page but fetch it differently
  async fallbackSearch(query) {
    try {
      // Try to fetch the search page and extract products from HTML
      const response = await fetch(
        `/search?q=${encodeURIComponent(query)}&type=product&view=ajax`,
        { signal: this.abortController.signal }
      );
      
      const html = await response.text();
      
      // Create a temporary div to parse HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      // Extract product cards (adjust selectors based on your theme)
      const productCards = tempDiv.querySelectorAll('.product-card, [data-product-card], .grid-item');
      
      const products = [];
      productCards.forEach((card, index) => {
        if (index < 3) { // Limit to 3
          const title = card.querySelector('.product-title, .title, h3')?.textContent?.trim();
          const price = card.querySelector('.price, .product-price')?.textContent?.trim();
          const image = card.querySelector('img')?.src;
          const url = card.querySelector('a')?.href;
          
          if (title && url) {
            products.push({
              title,
              price: price || '£0.00',
              image: image || '/placeholder.jpg',
              url
            });
          }
        }
      });
      
      if (products.length > 0) {
        this.renderResults(products, [], [], query);
        this.setExpanded(true);
      } else {
        this.showNoResults(query);
      }
      
    } catch (error) {
      console.error('Fallback search failed:', error);
      this.showNoResults(query);
    }
  }

  renderResults(products, queries, articles, query) {
    // Check if we should show query suggestions section
    // Show it if we have queries OR if we have products but no queries (common case)
    const shouldShowQuerySection = queries.length > 0 || (products.length > 0 && queries.length === 0);
    
    this.results.innerHTML = `
      <div class="predictive-search-layout">
        <div class="predictive-search-left">
          ${shouldShowQuerySection ? `
            <div class="predictive-search-group">
              <h4>${queries.length > 0 ? 'Popular Suggestions' : 'Popular Suggestions'}</h4>
              ${queries.length > 0 ? `
                <ul>
                  ${queries.slice(0, 3).map(q => `
                    <li>
                      <a href="/search?q=${encodeURIComponent(q.text)}">
                        ${q.text}
                      </a>
                    </li>
                  `).join('')}
                </ul>
              ` : `
                <ul>
                  <li>
                    <a href="/search?q=${encodeURIComponent(query)}">
                      Search for "${query}"
                    </a>
                  </li>
                  ${this.generateSearchSuggestions(query)}
                </ul>
              `}
            </div>
          ` : ''}

          <div class="predictive-search-group">
            <h4>Blogs & Recipes</h4>
            ${articles.length ? `
              <ul>
                ${articles.slice(0, 2).map(a => `
                  <li>
                    <a href="${a.url}">
                      ${a.title}
                    </a>
                  </li>
                `).join('')}
              </ul>
            ` : `
              <p class="no-results-message">No pages were found</p>
            `}
          </div>
        </div>

        ${products.length > 0 ? `
          <div class="predictive-search-right ${!shouldShowQuerySection ? 'full-width' : ''}">
            <h4>Products</h4>
            <div class="predictive-search-products">
              ${products.map(p => `
                <a href="${p.url}" class="predictive-product-card">
                  <img src="${p.image}" alt="${p.title}" loading="lazy" onerror="this.src='/placeholder.jpg'">
                  <div class="predictive-product-info">
                    <p class="title">${p.title}</p>
                    <p class="price">£${p.price}</p>
					<div class="jdgm-widget" data-id="${p.id}" data-show="rating" data-style="small-stars"></div>
                    ${p.available !== undefined ? `
                      <span class="availability-badge ${p.available ? 'in-stock' : 'out-of-stock'}">
                        ${p.available ? 'In Stock' : 'Out of Stock'}
                      </span>
                    ` : ''}
                  </div>
                </a>
              `).join('')}
            </div>
          </div>
        ` : ''}

        ${(products.length > 0 || queries.length > 0 || articles.length > 0) ? `
          <a href="/search?q=${encodeURIComponent(query)}&type=product" class="predictive-search-view-all">
            View all results →
          </a>
        ` : ''}
      </div>
    `;

	if (window.JudgeMeWidget && typeof window.JudgeMeWidget.initWidgets === 'function') {
		window.JudgeMeWidget.initWidgets();
	}
  }

  // Helper method to generate search suggestions when Shopify doesn't provide any
  generateSearchSuggestions(query) {
    const suggestions = [];
    const lowerQuery = query.toLowerCase();
    
    // Common patterns based on the query
    if (lowerQuery.includes('black')) {
      if (lowerQuery.includes('cu') || lowerQuery.includes('cur')) {
        suggestions.push('blackcurrant');
        suggestions.push('blackcurrant juice');
      } else {
        suggestions.push('blackberry');
        suggestions.push('black tea');
      }
    }
    
    // Generic fallbacks for any query
    if (query.length >= 3) {
      suggestions.push(`${query} products`);
      suggestions.push(`${query} collection`);
    }
    
    // Return as HTML string
    return suggestions.slice(0, 2).map(text => `
      <li>
        <a href="/search?q=${encodeURIComponent(text)}">
          ${text}
        </a>
      </li>
    `).join('');
  }

  showErrorMessage(query) {
    this.results.innerHTML = `
      <div class="predictive-search-layout">
        <div class="predictive-search-error">
          <p>Unable to load search results. Please try again.</p>
          <a href="/search?q=${encodeURIComponent(query)}" class="predictive-search-view-all">
            Try manual search →
          </a>
        </div>
      </div>
    `;
    this.setExpanded(true);
  }

  showNoResults(query) {
    this.results.innerHTML = `
      <div class="predictive-search-layout">
        <div class="predictive-search-no-results">
          <p>No results found for "${query}"</p>
          <a href="/search?q=${encodeURIComponent(query)}" class="predictive-search-view-all">
            Try a full search →
          </a>
        </div>
      </div>
    `;
    this.setExpanded(true);
  }

  setExpanded(open) {
    this.input.setAttribute('aria-expanded', open);
    this.results.style.display = open ? 'block' : 'none';
  }
}

customElements.define('predictive-search', PredictiveSearch);